import { render, staticRenderFns } from "./Cotacao.vue?vue&type=template&id=79842e0e&scoped=true"
import script from "./Cotacao.vue?vue&type=script&lang=js"
export * from "./Cotacao.vue?vue&type=script&lang=js"
import style0 from "./Cotacao.vue?vue&type=style&index=0&id=79842e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79842e0e",
  null
  
)

export default component.exports